@if (!appSettings.isMobile()) {
<div class="table-responsive table-data">
    <table class="table table-hover table-sm align-middle">
        <thead>
            <tr>
                <th class="text-uppercase fw-bold text-muted">Código</th>
                <th class="text-uppercase fw-bold text-muted">Nombre</th>
                <th class="text-uppercase fw-bold text-muted">Campus</th>
                <th class="text-uppercase fw-bold text-muted">Correo</th>
                <th class="text-uppercase fw-bold text-muted">CC</th>
                <th class="text-uppercase fw-bold text-muted">Estado</th>
                <th class="text-muted text-center" style="width: 7rem;"><i class="fas fa-cog"></i></th>
            </tr>
        </thead>
        <tbody>
            @if (isLoading()) {
                @for (i of skeletonRows; track $index) {
                    <tr class="placeholder-glow">
                        <td><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></td>
                        <td><span class="placeholder placeholder-sm col-10 bg-gray-500"></span></td>
                        <td><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                        <td><span class="placeholder placeholder-sm col-9 bg-gray-500"></span></td>
                        <td><span class="placeholder placeholder-sm col-7 bg-gray-500"></span></td>
                        <td><span class="placeholder placeholder-sm col-5 bg-gray-500"></span></td>
                        <td class="text-center">
                            <span class="placeholder placeholder-sm col-6 bg-gray-500"></span>
                        </td>
                    </tr>
                }
            } @else if (entities().length === 0) {
                <tr>
                    <td colspan="7" class="text-center text-muted py-5">
                        No hay entidades para mostrar.
                    </td>
                </tr>
            } @else {
                @for (entity of entities(); track entity.id) {
                    <tr [class.text-muted]="entity.isActive === false">
                        <td class="fw-bold">{{ entity.code }}</td>
                        <td>{{ entity.name }}</td>
                        <td>{{ entity.campus || '—' }}</td>
                        <td>{{ entity.mail || '—' }}</td>
                        <td>{{ entity.cc || '—' }}</td>
                        <td>
                            @if (entity.isActive === false) {
                                <span class="badge border border-secondary text-secondary">Inactiva</span>
                            } @else {
                                <span class="badge border border-success text-success">Activa</span>
                            }
                        </td>
                        <td class="text-center">
                            <button class="btn btn-outline-primary btn-xs" (click)="edit.emit(entity)">
                                <i class="fas fa-pencil-alt"></i>
                            </button>
                        </td>
                    </tr>
                }
            }
        </tbody>
    </table>
</div>
} @else {
<div class="d-flex justify-content-between align-items-center mb-2 px-1">
    <span class="small text-muted fw-bold text-uppercase">
        REGISTROS @if (!isLoading()) { ({{ entities().length }}) }
    </span>
</div>

<div class="mobile-cards-scroll">
    @if (isLoading()) {
        @for (i of skeletonRows; track $index) {
            <app-list-card [isLoading]="true"></app-list-card>
        }
    } @else {
        @for (entity of entities(); track entity.id) {
            <app-list-card
                [isShortcut]="true"
                (click)="edit.emit(entity)">
                <div cardTitle class="fw-bold text-dark text-truncate">
                    {{ entity.name }}
                </div>
                <div cardBadge>
                    <span class="badge"
                          [class.text-bg-success]="entity.isActive !== false"
                          [class.text-bg-secondary]="entity.isActive === false">
                        {{ entity.isActive === false ? 'Inactiva' : 'Activa' }}
                    </span>
                </div>
                <div class="row g-1 text-muted small">
                    <div class="col-6">
                        <span class="text-muted">Código</span>
                        <div class="fw-semibold text-dark">{{ entity.code }}</div>
                    </div>
                    <div class="col-6 text-end">
                        <span class="text-muted">Campus</span>
                        <div class="fw-semibold text-dark">{{ entity.campus || '—' }}</div>
                    </div>
                    <div class="col-12 mt-1">
                        <span class="text-muted">Correo</span>
                        <div class="text-truncate">{{ entity.mail || '—' }}</div>
                    </div>
                </div>
                <div cardExtra>{{ entity.cc || 'Sin CC' }}</div>
            </app-list-card>
        }
    }

    @if (!isLoading() && entities().length === 0) {
        <div class="card border-0 shadow-sm p-4 text-center my-2">
            <i class="fas fa-building fa-3x text-muted opacity-50 mb-2"></i>
            <h6 class="text-muted mb-1">Sin entidades</h6>
            <small class="text-muted">Ajusta la búsqueda o crea una nueva.</small>
        </div>
    }
</div>
}
